import { Component } from '@angular/core';
import { fadeInAnimation, fadeOutAnimation } from 'angular-animations';
import { Constants } from '../../constants';
import { SharedService } from '../../services/shared.service';

@Component({
  selector: 'app-background-local',
  templateUrl: './background-local.component.html',
  styleUrl: './background-local.component.scss',
  standalone: false,
  animations: [
    fadeInAnimation({ anchor: 'enter', duration: 1000, delay: 0 }),
    fadeOutAnimation({ anchor: 'leave', duration: 1000, delay: 0 })
  ]
})
export class BackgroundLocalComponent {
  animationStateIn = false;
  animationStateOut = false;
  color: string = "transparent";
  firstImage: string = "";
  secondImage: string = "";

constructor(private sharedService: SharedService) {
  }


  public setInitialValue(img: string | undefined, color: string | undefined = undefined) {
    console.log("BackgroundLocalComponent setInitialValue", img);
    this.firstImage = img ?? '';
    this.secondImage = img ?? '';
    this.color = color ?? "transparent";
  }

  public changeValue(img: string | undefined, color: string | undefined = undefined) {
    this.firstImage = img ?? '';
    this.secondImage = img ?? '';
    console.log("BackgroundLocalComponent changeValue", color);
    this.color = color ?? "transparent";
    this.animationStateOut = true;
  }

  public animOutDone() {
    console.log("BackgroundLocalComponent animOutDone");
      this.animationStateOut = false;
      this.firstImage = this.secondImage;
      this.animationStateIn = true;
  }

  private buildUrl(img: string): string {
    return img && !this.sharedService.isInBlob(img)? 
    this.sharedService.buildUrlBlob( img, Constants.Blob.Fonds) : img;
  }
}
